import axios from "axios";
import axiosInstance from "../axiosInterceptor";

export async function createPaymentSession(body) {
  const type = localStorage.getItem("serviceType");
  const payload = {
    name: body.name,
    line1: body.line1,
    postalCode: body.postal_code,
    city: body.city,
    state: body.state,
    country: body.country,
    questionId: body.question_id,
    paymentSection: type,
  };
  const response = await axiosInstance.post(
    `student/payment/getSessionData`,
    payload
  );
  const data = response?.data;
  return data;
}



export const getPaymentSession = async ({ data, token }) => {
  const apiEndPoint = process.env.REACT_APP_API;

  try {
    const res = await axios.post(
      `${apiEndPoint}student/payment/getSessionData`,
      {
        name: data?.billing?.name,
        line1: data?.billing?.address,
        postalCode: data?.billing?.postalCode,
        city: data?.billing?.city,
        state: data?.billing?.state,
        country: data?.billing?.country,
        questionId: data?.questionId,
        paymentSection: data?.paymentSection,
        paymentMethod: data?.paymentMethod,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return res?.data;
  } catch (error) {
    console.error("Payment Session Error:", error);
    throw error;
  }
};